(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
  class CollectionShowcase {
    constructor(section) {
      this.section = section;
      this.grid = this.section.querySelector('.collection-showcase__grid');

      if (!this.grid) return;

      this.resizeTimer = null;
      this.boundApplyLimit = this.applyMobileLimit.bind(this);
      this.boundHandleResize = this.handleResize.bind(this);

      this.init();
    }

    init() {
      // Only apply limit on mobile in grid mode
      if (this.grid.classList.contains('collection-showcase__grid--grid')) {
        this.applyMobileLimit();
        window.addEventListener('resize', this.boundHandleResize);
      }
    }

    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(this.boundApplyLimit, 250);
    }

    applyMobileLimit() {
      const isMobile = window.innerWidth < 750;
      const limitStr = this.grid.style.getPropertyValue('--mobile-products-limit').trim();
      const limit = parseInt(limitStr) || 4;
      const items = this.grid.querySelectorAll('.collection-showcase__item');

      items.forEach((item, index) => {
        if (isMobile && index >= limit) {
          item.classList.add('hidden-mobile');
        } else {
          item.classList.remove('hidden-mobile');
        }
      });
    }

    destroy() {
      window.removeEventListener('resize', this.boundHandleResize);
    }
  }

  // Store instances
  const showcaseInstances = new Map();

  function initializeShowcase(section) {
    const sectionId = section.dataset.sectionId;

    // Destroy existing instance
    if (showcaseInstances.has(sectionId)) {
      showcaseInstances.get(sectionId).destroy();
    }

    // Create new instance
    const instance = new CollectionShowcase(section);
    showcaseInstances.set(sectionId, instance);
  }

  // Initialize all sections on page load
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.collection-showcase');
    sections.forEach(section => initializeShowcase(section));
  });

  // Initialize on Shopify section load (theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.collection-showcase');
      if (section) {
        initializeShowcase(section);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('.collection-showcase');
      if (section) {
        const sectionId = section.dataset.sectionId;
        if (showcaseInstances.has(sectionId)) {
          showcaseInstances.get(sectionId).destroy();
          showcaseInstances.delete(sectionId);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtered-product-grid"] && !Shopify.designMode) return;
  try {
    
  class FilteredProductGrid {
    constructor(container) {
      this.container = container;
      this.filterButtons = container.querySelectorAll('[data-filter-button]');
      this.productItems = container.querySelectorAll('[data-product-item]');
      this.activeCategory = null;

      this.init();
    }

    init() {
      // 最初のボタンがあれば全商品を表示
      if (this.filterButtons.length > 0) {
        const firstButton = this.filterButtons[0];
        firstButton.classList.add('filtered-product-grid__filter-button--active');
        this.activeCategory = firstButton.dataset.category;

        // 初期表示: 最初のカテゴリの商品を表示
        this.filterProducts(this.activeCategory);
      } else {
        // ボタンがない場合は全商品を表示
        this.productItems.forEach((item) => {
          item.classList.remove('filtered-product-grid__product-item--hidden');
        });
      }

      // ボタンにイベントリスナーを追加
      this.filterButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          const category = e.currentTarget.dataset.category;
          this.setActiveButton(e.currentTarget);
          this.filterProducts(category);
        });
      });
    }

    setActiveButton(activeButton) {
      this.filterButtons.forEach((btn) => {
        btn.classList.remove('filtered-product-grid__filter-button--active');
      });
      activeButton.classList.add('filtered-product-grid__filter-button--active');
    }

    filterProducts(category) {
      this.activeCategory = category;

      this.productItems.forEach((item) => {
        const productType = item.dataset.productType;

        if (productType === category || productType.toUpperCase() === category.toUpperCase()) {
          item.classList.remove('filtered-product-grid__product-item--hidden');
        } else {
          item.classList.add('filtered-product-grid__product-item--hidden');
        }
      });
    }
  }

  // Shopifyのセクションレンダリング後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilteredProductGrid);
  } else {
    initFilteredProductGrid();
  }

  function initFilteredProductGrid() {
    const containers = document.querySelectorAll('.filtered-product-grid');
    containers.forEach((container) => {
      new FilteredProductGrid(container);
    });
  }

  // Shopifyのセクションレンダリングイベントにも対応
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('section-filtered-product-grid')) {
      initFilteredProductGrid();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 749px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll('.hero-carousel');

    carousels.forEach(function (carousel) {
      const track = carousel.querySelector('.hero-carousel__track');
      const originalSlides = Array.from(carousel.querySelectorAll('.hero-carousel__slide'));
      const dots = carousel.querySelectorAll('.hero-carousel__pagination-dot');

      if (originalSlides.length <= 1) return;

      // Timing constants
      const TIMING = {
        TRANSITION_DELAY: 300,
        TRANSITION_CLEANUP: 50,
        SCROLL_DEBOUNCE: 150,
        AUTOPLAY_START: 100,
        INFINITE_JUMP_DELAY: 500
      };

      const slideCount = originalSlides.length;
      let currentIndex = 0;
      let autoplayInterval;
      let isTransitioning = false;

      // Clone slides for infinite loop
      const clonedBefore = originalSlides.map(function (slide) {
        return slide.cloneNode(true);
      });
      const clonedAfter = originalSlides.map(function (slide) {
        return slide.cloneNode(true);
      });

      // Add clones to the track
      clonedBefore.forEach(function (clone) {
        track.insertBefore(clone, originalSlides[0]);
      });
      clonedAfter.forEach(function (clone) {
        track.appendChild(clone);
      });

      // Get all slides including clones
      const allSlides = Array.from(track.querySelectorAll('.hero-carousel__slide'));

      function updateActiveStates() {
        dots.forEach(function (dot, index) {
          if (index === currentIndex) {
            dot.classList.add('is-active');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.classList.remove('is-active');
            dot.setAttribute('aria-current', 'false');
          }
        });
      }

      /**
       * Calculate scroll offset to center a slide in the viewport
       * @param {HTMLElement} slide - The slide element to center
       * @returns {number} The scroll offset in pixels
       */
      function calculateScrollOffset(slide) {
        const slideRect = slide.getBoundingClientRect();
        const trackRect = track.getBoundingClientRect();
        return slideRect.left - trackRect.left + track.scrollLeft - trackRect.width / 2 + slideRect.width / 2;
      }

      /**
       * Scroll to a slide by its index in the allSlides array
       * @param {number} slideIndex - The index of the slide (includes clones)
       * @param {string} behavior - 'smooth' or 'auto'
       */
      function scrollToSlideByIndex(slideIndex, behavior) {
        const scrollOffset = calculateScrollOffset(allSlides[slideIndex]);
        track.scrollTo({
          left: scrollOffset,
          behavior: behavior,
        });
      }

      function scrollToSlide(index, smooth) {
        if (isTransitioning) return;

        const behavior = smooth === false ? 'auto' : 'smooth';
        const actualIndex = index + slideCount;
        scrollToSlideByIndex(actualIndex, behavior);
        updateActiveStates();
      }

      /**
       * Helper to handle clone jump transitions
       * @param {number} realIndex - The logical index to jump to
       */
      function handleCloneJump(realIndex) {
        currentIndex = realIndex;
        isTransitioning = true;
        stopAutoplay();

        setTimeout(function () {
          scrollToSlide(currentIndex, false);
          setTimeout(function () {
            isTransitioning = false;
            startAutoplay();
          }, TIMING.TRANSITION_CLEANUP);
        }, TIMING.TRANSITION_DELAY);
      }

      /**
       * Handle infinite scroll detection and jump to original slides when needed
       */
      function handleInfiniteScroll() {
        const closestIndex = findCenteredSlideIndex();

        // Check if we're at a cloned slide and need to jump
        if (closestIndex < slideCount) {
          // We're in the before clones, jump to the corresponding original
          handleCloneJump(closestIndex);
        } else if (closestIndex >= slideCount * 2) {
          // We're in the after clones, jump to the corresponding original
          handleCloneJump(closestIndex - slideCount * 2);
        } else {
          // We're in the original slides
          currentIndex = closestIndex - slideCount;
        }

        updateActiveStates();
      }

      /**
       * Find the physical index of the slide currently centered in the viewport
       * @returns {number} The index in allSlides array (includes cloned slides)
       */
      function findCenteredSlideIndex() {
        const trackRect = track.getBoundingClientRect();
        const trackCenter = trackRect.left + trackRect.width / 2;

        let closestIndex = currentIndex + slideCount;
        let minDistance = Infinity;

        allSlides.forEach(function (slide, index) {
          const slideRect = slide.getBoundingClientRect();
          const slideCenter = slideRect.left + slideRect.width / 2;
          const distance = Math.abs(slideCenter - trackCenter);
          if (distance < minDistance) {
            minDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      /**
       * Handle infinite loop jump after animation completes
       * @param {number} targetIndex - The physical index to jump to
       * @param {number} [delay] - Optional delay before jump (default: 500ms)
       */
      function handleInfiniteLoopJump(targetIndex, delay) {
        isTransitioning = true;
        stopAutoplay();
        setTimeout(function () {
          scrollToSlideByIndex(targetIndex, 'auto');
          isTransitioning = false;
          startAutoplay();
        }, delay || TIMING.INFINITE_JUMP_DELAY);
      }

      function goToNext() {
        if (isTransitioning) return;

        const currentPhysicalIndex = findCenteredSlideIndex();
        const nextPhysicalIndex = currentPhysicalIndex + 1;

        // Check if next index is out of bounds
        if (nextPhysicalIndex >= allSlides.length) {
          return;
        }

        // Scroll to next slide with smooth animation
        scrollToSlideByIndex(nextPhysicalIndex, 'smooth');

        // Update logical index
        currentIndex = (currentIndex + 1) % slideCount;
        updateActiveStates();

        // Check if we just moved to the first cloned slide (after all originals)
        if (nextPhysicalIndex === slideCount * 2) {
          handleInfiniteLoopJump(slideCount);
        }
      }

      function goToPrev() {
        if (isTransitioning) return;

        const currentPhysicalIndex = findCenteredSlideIndex();
        const prevPhysicalIndex = currentPhysicalIndex - 1;

        // Check if previous index is out of bounds
        if (prevPhysicalIndex < 0) {
          return;
        }

        // Scroll to previous slide with smooth animation
        scrollToSlideByIndex(prevPhysicalIndex, 'smooth');

        // Update logical index
        currentIndex = (currentIndex - 1 + slideCount) % slideCount;
        updateActiveStates();

        // Check if we just moved to the last cloned slide (before all originals)
        if (prevPhysicalIndex === slideCount - 1) {
          handleInfiniteLoopJump(slideCount * 2 - 1);
        }
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          currentIndex = index;
          scrollToSlide(currentIndex, true);
          resetAutoplay();
        });

        // Add keyboard navigation support
        dot.addEventListener('keydown', function (e) {
          let newIndex = currentIndex;

          if (e.key === 'ArrowLeft' || e.key === 'Left') {
            e.preventDefault();
            newIndex = (currentIndex - 1 + slideCount) % slideCount;
          } else if (e.key === 'ArrowRight' || e.key === 'Right') {
            e.preventDefault();
            newIndex = (currentIndex + 1) % slideCount;
          } else if (e.key === 'Home') {
            e.preventDefault();
            newIndex = 0;
          } else if (e.key === 'End') {
            e.preventDefault();
            newIndex = slideCount - 1;
          } else {
            return;
          }

          currentIndex = newIndex;
          scrollToSlide(currentIndex, true);
          resetAutoplay();
          dots[newIndex].focus();
        });
      });

      function startAutoplay() {
        // Always clear any existing interval first
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }

        // Validate and clamp autoplay delay between 2-10 seconds
        const rawDelay = parseInt(carousel.dataset.autoplayDelay || '5', 10);
        const autoplayDelay = Math.max(2, Math.min(10, rawDelay)) * 1000;
        autoplayInterval = setInterval(goToNext, autoplayDelay);
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      function resetAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      // Detect manual scroll with debouncing for better performance
      let scrollTimeout;
      let rafId;
      track.addEventListener('scroll', function () {
        if (isTransitioning) return;

        // Cancel any pending animation frame
        if (rafId) {
          cancelAnimationFrame(rafId);
        }

        clearTimeout(scrollTimeout);

        // Use requestAnimationFrame for smoother updates
        rafId = requestAnimationFrame(function () {
          scrollTimeout = setTimeout(handleInfiniteScroll, TIMING.SCROLL_DEBOUNCE);
        });
      });

      // Add touch event for better mobile responsiveness
      track.addEventListener('touchend', function () {
        if (isTransitioning) return;
        if (rafId) cancelAnimationFrame(rafId);
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(handleInfiniteScroll, TIMING.SCROLL_DEBOUNCE);
      });

      // Pause on hover
      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);

      // Initialize - scroll to first real slide without animation
      scrollToSlide(0, false);
      updateActiveStates();

      // Start autoplay after a short delay
      setTimeout(startAutoplay, TIMING.AUTOPLAY_START);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["like-items"] && !Shopify.designMode) return;
  try {
    
  class LikeItemsSection {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.grid = document.querySelector(`#like-items-grid-${sectionId}`);
      this.section = document.querySelector('.like-items');
      this.maxRetries = 3;
      this.retryDelay = 500;

      if (!this.grid || !this.section) {
        return;
      }

      this.showBadge = this.grid.dataset.showBadge === 'true';
      this.showVendor = this.grid.dataset.showVendor === 'true';
      this.showLikes = this.grid.dataset.showLikes === 'true';
      this.productsLimit = parseInt(this.grid.dataset.productsLimit) || 10;

      this.soldOutText = this.section.dataset.soldOutText || 'Sold out';
      this.saleText = this.section.dataset.saleText || 'Sale';

      this.initWithRetry();
    }

    async initWithRetry(attempt = 0) {
      if (!window.ProductCardRenderer) {
        if (attempt < this.maxRetries) {
          setTimeout(() => this.initWithRetry(attempt + 1), this.retryDelay);
          return;
        }
        return;
      }

      this.init();
    }

    async init() {
      const hasFallback = this.grid.querySelector('.like-items__item--fallback');
      const hasEmptyState = this.grid.querySelector('.like-items__empty');
      
      if (hasFallback || hasEmptyState) {
        return;
      }

      this.showEmptyState();
    }

    showEmptyState() {
      const emptyDiv = document.createElement('div');
      emptyDiv.className = 'like-items__empty';
      emptyDiv.innerHTML = `
        <p class="like-items__empty-message">
          ${this.section.dataset.emptyMessage || 'No favorite items'}
        </p>
      `;
      this.grid.appendChild(emptyDiv);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLikeItems);
  } else {
    initLikeItems();
  }

  function initLikeItems() {
    const section = document.querySelector('.like-items');
    if (!section) return;

    const grid = section.querySelector('[id^="like-items-grid-"]');
    if (!grid) return;

    const sectionId = grid.id.replace('like-items-grid-', '');
    new LikeItemsSection(sectionId);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-checked"] && !Shopify.designMode) return;
  try {
    
  class RecentlyCheckedSection {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.grid = document.querySelector(`#recently-checked-grid-${sectionId}`);
      this.section = document.querySelector('.recently-checked');
      this.maxRetries = 3;
      this.retryDelay = 500;

      if (!this.grid || !this.section) {
        return;
      }

      this.showBadge = this.grid.dataset.showBadge === 'true';
      this.showVendor = this.grid.dataset.showVendor === 'true';
      this.showLikes = this.grid.dataset.showLikes === 'true';
      this.productsLimit = parseInt(this.grid.dataset.productsLimit) || 10;

      // Get translated badge text from data attributes
      this.soldOutText = this.section.dataset.soldOutText || 'Sold out';
      this.saleText = this.section.dataset.saleText || 'Sale';

      this.initWithRetry();
    }

    async initWithRetry(attempt = 0) {
      if (!window.RecentlyViewed) {
        if (attempt < this.maxRetries) {
          setTimeout(() => this.initWithRetry(attempt + 1), this.retryDelay);
          return;
        }
        return;
      }

      this.init();
    }

    async init() {
      const handles = window.RecentlyViewed.getProductHandles(this.productsLimit);

      if (handles.length === 0) {
        const hasFallback = this.grid.querySelector('.recently-checked__item--fallback');
        const hasEmptyState = this.grid.querySelector('.recently-checked__empty');
        if (!hasFallback && !hasEmptyState) {
          this.showEmptyState();
        }
        return;
      }

      this.grid.querySelectorAll('.recently-checked__item--fallback').forEach(item => item.remove());
      this.grid.querySelectorAll('.recently-checked__empty').forEach(item => item.remove());

      await this.fetchAndRenderProducts(handles);
    }

    async fetchAndRenderProducts(handles) {
      // Fetch products in batches for better performance
      const products = await this.fetchProductsBatch(handles);

      // Render each product using ProductCardRenderer
      products.forEach(product => {
        if (product) {
          this.renderProductCard(product);
        }
      });
    }

    async fetchProductsBatch(handles) {
      // Batch size to avoid overwhelming the browser
      const batchSize = 3;
      const products = [];

      for (let i = 0; i < handles.length; i += batchSize) {
        const batch = handles.slice(i, i + batchSize);
        const promises = batch.map(handle => this.fetchProduct(handle));
        const batchResults = await Promise.all(promises);
        products.push(...batchResults);
      }

      return products.filter(p => p !== null);
    }

    async fetchProduct(handle) {
      try {
        const response = await fetch(`${window.Shopify.routes.root}products/${handle}.js`);

        if (!response.ok) {
          console.error(`Failed to fetch product ${handle}`);
          return null;
        }

        return await response.json();
      } catch (error) {
        console.error(`Error fetching product ${handle}:`, error);
        return null;
      }
    }

    renderProductCard(product) {
      if (!window.ProductCardRenderer) {
        console.error('ProductCardRenderer not loaded');
        return;
      }

      const card = window.ProductCardRenderer.render(product, {
        show_badge: this.showBadge,
        show_vendor: this.showVendor,
        show_likes: this.showLikes,
        likes_count: 236,
        image_ratio: 'portrait',
        sold_out_text: this.soldOutText,
        sale_text: this.saleText
      });

      const item = document.createElement('div');
      item.className = 'recently-checked__item';
      item.appendChild(card);
      this.grid.appendChild(item);
    }

    showEmptyState() {
      const emptyDiv = document.createElement('div');
      emptyDiv.className = 'recently-checked__empty';
      emptyDiv.innerHTML = `
        <p class="recently-checked__empty-message">
          ${this.section.dataset.emptyMessage || 'No browsing history'}
        </p>
      `;
      this.grid.appendChild(emptyDiv);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecentlyChecked);
  } else {
    initRecentlyChecked();
  }

  function initRecentlyChecked() {
    const section = document.querySelector('.recently-checked');
    if (!section) return;

    const grid = section.querySelector('[id^="recently-checked-grid-"]');
    if (!grid) return;

    const sectionId = grid.id.replace('recently-checked-grid-', '');
    new RecentlyCheckedSection(sectionId);
  }

  } catch(e) { console.error(e); }
})();
})();
